import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, useUserSettingsStore } from '@pascal/pascal-core';

import { loadingStore } from '../../store/loadingStore';
import { soundService, soundTypes } from '../../services/soundService';

import { useUpdateEffect } from '../../hooks/useUpdateEffect';

const SoundWatcher = observer(() => {
  const { isMusicOn, isSoundOn, musicVolume, soundVolume } = useUserSettingsStore();
  const { gameLoading, timerFinished } = loadingStore;
  const [isClickedDocument, setIsClickedDocument] = useState(false);

  const muteMusicAndSounds = useCallback(() => {
    soundService.muteMusic(document.hidden ? true : !isMusicOn);
    soundService.muteSounds(document.hidden ? true : !isSoundOn);
  }, [isMusicOn, isSoundOn]);

  const handleDocumentClick = useCallback(() => {
    setIsClickedDocument(true);
    document.removeEventListener('click', handleDocumentClick);
  }, []);

  const playMusic = () => {
    if (isMusicOn === true && isClickedDocument && !gameLoading) {
      setIsClickedDocument(true);
    }

    if (!isSoundOn) {
      soundService.muteSounds(true);
    }
    document.removeEventListener('click', playMusic);
  };

  useUpdateEffect(() => {
    if (isClickedDocument) {
      soundService.changeMusicVolume(+musicVolume);
      soundService.play(soundTypes.music);
    }
    // eslint-disable-next-line
  }, [isClickedDocument]);

  useUpdateEffect(() => {
    soundService.muteMusic(true);
    soundService.muteSounds(true);
    if (!gameLoading) {
      soundService.muteMusic(!isMusicOn);
      soundService.muteSounds(!isSoundOn);
      soundService.play(soundTypes.music);
    }
    // eslint-disable-next-line
  }, [gameLoading]);

  useUpdateEffect(() => {
    if (!gameLoading) {
      document.addEventListener('click', playMusic);
      soundService.changeMusicVolume(+musicVolume);
      playMusic(+musicVolume);
      // }
    }
  }, [gameLoading, isMusicOn, isClickedDocument]);

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    soundService.changeMusicVolume(+musicVolume);
    soundService.changeSoundsVolume(+soundVolume);
    return () => {
      soundService.stopAll();
      document.removeEventListener('click', playMusic);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isMobile()) {
      document.addEventListener('visibilitychange', muteMusicAndSounds);
    }
    return () => {
      if (isMobile()) {
        document.removeEventListener('visibilitychange', muteMusicAndSounds);
      }
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    soundService.muteMusic(true);
    soundService.muteSounds(true);
    if (!gameLoading && timerFinished) {
      soundService.muteMusic(!isMusicOn);
      soundService.muteSounds(!isSoundOn);
      soundService.play(soundTypes.music);
    }
    // eslint-disable-next-line
  }, [gameLoading, timerFinished]);

  return null;
});

export default SoundWatcher;
